<template>
  <div>
    <el-row class="u-mt-10 u-mb-20">
      <el-col :xs="24" :sm="16" :md="16">
        <el-input v-model="filtroText" placeholder="Filtrar por fornecedor..." @keyup.native.enter="loadingPropostas"></el-input>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
        <el-button type="primary" @click="openDialog()">NOVA PROPOSTA</el-button>
      </el-col>
    </el-row>

    <div class="container-table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="hidden-mobile" style="width: 70px;">cod</th>
            <th>Fornecedor</th>
            <th class="hidden-mobile u-text-right">Valor</th>
            <th class="hidden-mobile u-text-center">Vencedor</th>
            <th style="width: 220px;" class="u-text-center">Ação</th>
          </tr>
        </thead>
        <tbody v-if="statusList">
          <tr v-for="item in propostasFiltradas" :key="item.id">
            <td class="hidden-mobile">{{ item.id }}</td>
            <td>{{ item.fornecedor ? item.fornecedor.nome : ('#' + item.fornecedor_id) }}</td>
            <td class="hidden-mobile u-text-right">{{ formatMoney(item.valor_total) }}</td>
            <td class="hidden-mobile u-text-center">{{ item.vencedor ? 'SIM' : 'NÃO' }}</td>
            <td class="u-text-center acao">
              <router-link :to="'/admin/financeiro/proposta/' + item.id + '/itens'" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                <el-button type="primary" title="Itens" icon="el-icon-tickets" size="mini" plain></el-button>
              </router-link>
              <el-button @click="openDialog(item)" title="Editar" type="info" icon="el-icon-edit" size="mini" plain></el-button>
              <el-button class="u-ml-10" @click="markVencedor(item)" title="Marcar vencedor" type="success" icon="el-icon-check" size="mini" plain></el-button>
              <el-button class="u-ml-10" @click="deleteProposta(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="!statusList" class="u-text-center u-mt-25">
        <img src="/public/img/loading-bar.gif" />
      </div>
    </div>

    <el-dialog append-to-body :title="dialogEdit ? 'Editar Proposta' : 'Nova Proposta'" :visible.sync="dialogVisible" width="70%" top="5vh">
      <el-form :model="form" ref="form" label-position="top">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="Fornecedor" prop="fornecedor_id" :rules="[$requiredChange]" key="fornecedor_id">
              <el-select v-model="form.fornecedor_id" placeholder="pesquisar..." filterable remote :remote-method="getFornecedorByFilter" :loading="loadingFornecedor">
                <el-option v-for="item in fornecedores" :key="item.id" :label="item.nome" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Valor total" prop="valor_total" :rules="[$requiredBlur]" key="valor_total">
              <el-input v-model="form.valor_total"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Data da proposta" prop="data_proposta" key="data_proposta">
              <el-date-picker v-model="form.data_proposta" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Arquivo (referência)" prop="arquivo_proposta" key="arquivo_proposta">
              <el-input v-model="form.arquivo_proposta" maxlength="191"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Vencedor" prop="vencedor" key="vencedor">
              <el-select v-model="form.vencedor">
                <el-option :key="true" label="SIM" :value="true"></el-option>
                <el-option :key="false" label="NÃO" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">CANCELAR</el-button>
        <el-button class="u-ml-10" type="primary" @click="saveProposta">SALVAR</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    statusList: false,
    filtroText: '',
    propostas: [],
    paginate: { page: 1 },
    dialogVisible: false,
    dialogEdit: false,
    loadingFornecedor: false,
    fornecedores: [],
    form: {
      id: '',
      cotacao_id: '',
      fornecedor_id: '',
      valor_total: '',
      data_proposta: '',
      arquivo_proposta: '',
      vencedor: false
    }
  }),
  mounted () {
    this.loadingPropostas()
  },
  computed: {
    cotacaoId () {
      return this.$route.params.cotacao_id
    },
    propostasFiltradas () {
      if (!this.filtroText) return this.propostas
      const q = String(this.filtroText).toLowerCase()
      return this.propostas.filter(i => (i.fornecedor && i.fornecedor.nome ? i.fornecedor.nome : '').toLowerCase().includes(q))
    }
  },
  methods: {
    loadingPropostas () {
      this.statusList = false
      this.propostas = []
      const filtro = { cotacao_id: this.cotacaoId }
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/proposta/getAllPaginate?page=` + this.paginate.page, filtro, this.$store.getters.getHeaderAuth)
        .then(response => {
          this.propostas = response.data.data
          this.statusList = true
        }).catch((error) => { this.$store.commit('throwException', error) })
    },
    openDialog (item = null) {
      this.dialogVisible = true
      this.dialogEdit = !!item
      if (item) {
        this.form = Object.assign({}, item)
      } else {
        this.form = { id: '', cotacao_id: this.cotacaoId, fornecedor_id: '', valor_total: '', data_proposta: '', arquivo_proposta: '', vencedor: false }
      }
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    getFornecedorByFilter (query) {
      if (!query || query.length < 2) {
        this.fornecedores = []
        return false
      }
      this.loadingFornecedor = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/fornecedor/searchByNome`, { query }, this.$store.getters.getHeaderAuth).then(response => {
        this.fornecedores = JSON.parse(JSON.stringify(response.data))
        this.loadingFornecedor = false
      }).catch((error) => { this.loadingFornecedor = false; this.$store.commit('throwException', error) })
    },
    saveProposta () {
      this.$refs.form.validate((valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        window.eventBus.$emit('loading', true)
        const payload = Object.assign({}, this.form, { cotacao_id: this.cotacaoId })
        if (this.dialogEdit) {
          this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/proposta/update/` + payload.id, payload, this.$store.getters.getHeaderAuth).then(() => {
            window.eventBus.$emit('loading', false)
            window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
            this.dialogVisible = false
            this.loadingPropostas()
          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        } else {
          this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/proposta/store`, payload, this.$store.getters.getHeaderAuth).then(() => {
            window.eventBus.$emit('loading', false)
            window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
            this.dialogVisible = false
            this.loadingPropostas()
          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }
      })
    },
    markVencedor (item) {
      // Nota: a API atual não faz "unmark" automático das outras propostas
      const payload = Object.assign({}, item, { vencedor: true })
      window.eventBus.$emit('loading', true)
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/proposta/update/` + item.id, payload, this.$store.getters.getHeaderAuth).then(() => {
        window.eventBus.$emit('loading', false)
        window.eventBus.$emit('alert', { msg: 'Vencedor marcado. (Se houver mais de um, ajuste manualmente).', type: 'success' })
        this.loadingPropostas()
      }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
    },
    deleteProposta (id) {
      this.$msgbox.confirm('Tem certeza que deseja excluir esta proposta?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          window.eventBus.$emit('loading', true)
          this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/financeiro/proposta/delete/` + id, this.$store.getters.getHeaderAuth).then(() => {
            window.eventBus.$emit('loading', false)
            window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
            this.loadingPropostas()
          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }).catch(() => { })
    },
    formatMoney (value) {
      const v = Number(value || 0)
      return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    }
  }
}
</script>

